import type { FC } from 'react';

import type { IconPropsT } from './Icon';
import Icon from './Icon';

const CriticalPriorityIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */

  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Critical</title>
        <path
          d="M7.984436 3.200867l-4.5 2.7c-.5.3-1.1.1-1.3-.4s-.2-1.1.3-1.3l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3l-4.4-2.7z"
          fill="#ff5630"
        />
        <path
          d="M3.484436 10.200867c-.5.3-1.1.1-1.3-.3s-.2-1.1.3-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3l-4.4-2.7-4.5 2.7z"
          fill="#ff7452"
        />
        <path
          d="M3.484436 14.500867c-.5.3-1.1.2-1.3-.3s-.2-1.1.3-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3l-4.4-2.7-4.5 2.7z"
          fill="#ff8f73"
        />
      </svg>
    </Icon>
  );
};

export default CriticalPriorityIcon;
